import { Controller } from 'stimulus'

const RELOAD_INTERVAL = 60000

export default class extends Controller {
  static targets = ['frame']

  connect() {
    this.interval = setInterval(() => this.reload(), RELOAD_INTERVAL)
  }

  disconnect() {
    clearInterval(this.interval)
  }

  keepCurrentBell(event) {
    event.preventDefault()
  }

  reload() {
    if (document.hidden || this.element.querySelector('.show')) return

    this.frameTarget.reload()
  }
}
